var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.body_show)?_c('div',[_c('div',{staticClass:"task_f task_fqa"},[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.faq_content.content)}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }